import { initLiveList } from '../../shared/liveList.js';

// The audit log's filter, search and paging.
//
// Nothing else: the log is read-only, so there is no create link, no row action
// and no dialog to wire - initFormModalLinks has nothing to bind to here, and
// that absence is the point of the page.
export function initAuditList() {
  // initLiveList returns early when #audit-list is not on the page, which is
  // what lets main.js call this unconditionally.
  initLiveList({
    results: 'audit-list',
    path: '/audit',
    forms: ['audit-filter', 'audit-search']
  });
}
